import _slicedToArray from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { bigIntToBytes, intToBigInt } from '@stacks/common';
import { makeContractCall, bufferCV, uintCV, tupleCV, ClarityType, broadcastTransaction, standardPrincipalCV, callReadOnlyFunction, cvToString, noneCV, someCV, validateStacksAddress, AnchorMode, getFee } from '@stacks/transactions';
import { StackingErrors } from './constants';
import { decodeBtcAddress } from './utils';
export * from './utils';
export var StackingClient =
/*#__PURE__*/
function () {
  function StackingClient(address, network) {
    _classCallCheck(this, StackingClient);

    this.address = address;
    this.network = network;
  }

  _createClass(StackingClient, [{
    key: "getCoreInfo",
    value: function () {
      var _getCoreInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = this.network.getInfoUrl();
                return _context.abrupt("return", this.network.fetchFn(url).then(function (res) {
                  return res.json();
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCoreInfo() {
        return _getCoreInfo.apply(this, arguments);
      }

      return getCoreInfo;
    }()
  }, {
    key: "getPoxInfo",
    value: function () {
      var _getPoxInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var url;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = this.network.getPoxInfoUrl();
                return _context2.abrupt("return", this.network.fetchFn(url).then(function (res) {
                  return res.json();
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getPoxInfo() {
        return _getPoxInfo.apply(this, arguments);
      }

      return getPoxInfo;
    }()
  }, {
    key: "getTargetBlockTime",
    value: function () {
      var _getTargetBlockTime = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var url, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = this.network.getBlockTimeInfoUrl();
                _context3.next = 3;
                return this.network.fetchFn(url).then(function (res) {
                  return res.json();
                });

              case 3:
                res = _context3.sent;

                if (!this.network.isMainnet()) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", res.mainnet.target_block_time);

              case 8:
                return _context3.abrupt("return", res.testnet.target_block_time);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getTargetBlockTime() {
        return _getTargetBlockTime.apply(this, arguments);
      }

      return getTargetBlockTime;
    }()
  }, {
    key: "getAccountStatus",
    value: function () {
      var _getAccountStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var url;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = this.network.getAccountApiUrl(this.address);
                return _context4.abrupt("return", this.network.fetchFn(url).then(function (res) {
                  return res.json();
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAccountStatus() {
        return _getAccountStatus.apply(this, arguments);
      }

      return getAccountStatus;
    }()
  }, {
    key: "getAccountBalance",
    value: function () {
      var _getAccountBalance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.getAccountStatus().then(function (res) {
                  return BigInt(res.balance);
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getAccountBalance() {
        return _getAccountBalance.apply(this, arguments);
      }

      return getAccountBalance;
    }()
  }, {
    key: "getCycleDuration",
    value: function () {
      var _getCycleDuration = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var poxInfoPromise, targetBlockTimePromise;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                poxInfoPromise = this.getPoxInfo();
                _context6.next = 3;
                return this.getTargetBlockTime();

              case 3:
                targetBlockTimePromise = _context6.sent;
                return _context6.abrupt("return", Promise.all([poxInfoPromise, targetBlockTimePromise]).then(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      poxInfo = _ref2[0],
                      targetBlockTime = _ref2[1];

                  return poxInfo.reward_cycle_length * targetBlockTime;
                }));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getCycleDuration() {
        return _getCycleDuration.apply(this, arguments);
      }

      return getCycleDuration;
    }()
  }, {
    key: "getRewardsTotalForBtcAddress",
    value: function () {
      var _getRewardsTotalForBtcAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var url;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                url = this.network.getRewardsTotalUrl(this.address);
                return _context7.abrupt("return", this.network.fetchFn(url).then(function (res) {
                  return res.json();
                }));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getRewardsTotalForBtcAddress() {
        return _getRewardsTotalForBtcAddress.apply(this, arguments);
      }

      return getRewardsTotalForBtcAddress;
    }()
  }, {
    key: "getRewardsForBtcAddress",
    value: function () {
      var _getRewardsForBtcAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(options) {
        var url;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                url = "".concat(this.network.getRewardsUrl(this.address, options));
                return _context8.abrupt("return", this.network.fetchFn(url).then(function (res) {
                  return res.json();
                }));

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getRewardsForBtcAddress(_x) {
        return _getRewardsForBtcAddress.apply(this, arguments);
      }

      return getRewardsForBtcAddress;
    }()
  }, {
    key: "getRewardHoldersForBtcAddress",
    value: function () {
      var _getRewardHoldersForBtcAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(options) {
        var url;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                url = "".concat(this.network.getRewardHoldersUrl(this.address, options));
                return _context9.abrupt("return", this.network.fetchFn(url).then(function (res) {
                  return res.json();
                }));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getRewardHoldersForBtcAddress(_x2) {
        return _getRewardHoldersForBtcAddress.apply(this, arguments);
      }

      return getRewardHoldersForBtcAddress;
    }()
  }, {
    key: "getSecondsUntilNextCycle",
    value: function () {
      var _getSecondsUntilNextCycle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var poxInfoPromise, targetBlockTimePromise, coreInfoPromise;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                poxInfoPromise = this.getPoxInfo();
                _context10.next = 3;
                return this.getTargetBlockTime();

              case 3:
                targetBlockTimePromise = _context10.sent;
                coreInfoPromise = this.getCoreInfo();
                return _context10.abrupt("return", Promise.all([poxInfoPromise, targetBlockTimePromise, coreInfoPromise]).then(function (_ref3) {
                  var _ref4 = _slicedToArray(_ref3, 3),
                      poxInfo = _ref4[0],
                      targetBlockTime = _ref4[1],
                      coreInfo = _ref4[2];

                  var blocksToNextCycle = poxInfo.reward_cycle_length - (coreInfo.burn_block_height - poxInfo.first_burnchain_block_height) % poxInfo.reward_cycle_length;
                  return blocksToNextCycle * targetBlockTime;
                }));

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getSecondsUntilNextCycle() {
        return _getSecondsUntilNextCycle.apply(this, arguments);
      }

      return getSecondsUntilNextCycle;
    }()
  }, {
    key: "isStackingEnabledNextCycle",
    value: function () {
      var _isStackingEnabledNextCycle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.getPoxInfo();

              case 2:
                _context11.t0 = _context11.sent.rejection_votes_left_required;
                return _context11.abrupt("return", _context11.t0 > 0);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function isStackingEnabledNextCycle() {
        return _isStackingEnabledNextCycle.apply(this, arguments);
      }

      return isStackingEnabledNextCycle;
    }()
  }, {
    key: "hasMinimumStx",
    value: function () {
      var _hasMinimumStx = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var balance, min;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.getAccountBalance();

              case 2:
                balance = _context12.sent;
                _context12.t0 = BigInt;
                _context12.next = 6;
                return this.getPoxInfo();

              case 6:
                _context12.t1 = _context12.sent.min_amount_ustx;
                min = (0, _context12.t0)(_context12.t1);
                return _context12.abrupt("return", balance >= min);

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function hasMinimumStx() {
        return _hasMinimumStx.apply(this, arguments);
      }

      return hasMinimumStx;
    }()
  }, {
    key: "canStack",
    value: function () {
      var _canStack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(_ref5) {
        var _this = this;

        var poxAddress, cycles, balancePromise, poxInfoPromise;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                poxAddress = _ref5.poxAddress, cycles = _ref5.cycles;
                balancePromise = this.getAccountBalance();
                poxInfoPromise = this.getPoxInfo();
                return _context13.abrupt("return", Promise.all([balancePromise, poxInfoPromise]).then(function (_ref6) {
                  var _ref7 = _slicedToArray(_ref6, 2),
                      balance = _ref7[0],
                      poxInfo = _ref7[1];

                  var _decodeBtcAddress = decodeBtcAddress(poxAddress),
                      hashMode = _decodeBtcAddress.hashMode,
                      data = _decodeBtcAddress.data;

                  var hashModeBuffer = bufferCV(bigIntToBytes(BigInt(hashMode), 1));
                  var hashbytes = bufferCV(data);
                  var poxAddressCV = tupleCV({
                    hashbytes: hashbytes,
                    version: hashModeBuffer
                  });

                  var _this$parseContractId = _this.parseContractId(poxInfo.contract_id),
                      _this$parseContractId2 = _slicedToArray(_this$parseContractId, 2),
                      contractAddress = _this$parseContractId2[0],
                      contractName = _this$parseContractId2[1];

                  return callReadOnlyFunction({
                    network: _this.network,
                    contractName: contractName,
                    contractAddress: contractAddress,
                    functionName: 'can-stack-stx',
                    senderAddress: _this.address,
                    functionArgs: [poxAddressCV, uintCV(balance.toString()), uintCV(poxInfo.reward_cycle_id), uintCV(cycles.toString())]
                  });
                }).then(function (responseCV) {
                  if (responseCV.type === ClarityType.ResponseOk) {
                    return {
                      eligible: true
                    };
                  } else {
                    var errorCV = responseCV;
                    return {
                      eligible: false,
                      reason: StackingErrors[+cvToString(errorCV.value)]
                    };
                  }
                }));

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function canStack(_x3) {
        return _canStack.apply(this, arguments);
      }

      return canStack;
    }()
  }, {
    key: "stack",
    value: function () {
      var _stack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(_ref8) {
        var amountMicroStx, poxAddress, cycles, privateKey, burnBlockHeight, poxInfo, contract, txOptions, tx;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                amountMicroStx = _ref8.amountMicroStx, poxAddress = _ref8.poxAddress, cycles = _ref8.cycles, privateKey = _ref8.privateKey, burnBlockHeight = _ref8.burnBlockHeight;
                _context14.next = 3;
                return this.getPoxInfo();

              case 3:
                poxInfo = _context14.sent;
                contract = poxInfo.contract_id;
                txOptions = this.getStackOptions({
                  amountMicroStx: amountMicroStx,
                  cycles: cycles,
                  poxAddress: poxAddress,
                  contract: contract,
                  burnBlockHeight: burnBlockHeight
                });
                _context14.next = 8;
                return makeContractCall(Object.assign(Object.assign({}, txOptions), {
                  senderKey: privateKey
                }));

              case 8:
                tx = _context14.sent;
                return _context14.abrupt("return", broadcastTransaction(tx, txOptions.network));

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function stack(_x4) {
        return _stack.apply(this, arguments);
      }

      return stack;
    }()
  }, {
    key: "delegateStx",
    value: function () {
      var _delegateStx = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(_ref9) {
        var amountMicroStx, delegateTo, untilBurnBlockHeight, poxAddress, privateKey, poxInfo, contract, txOptions, tx;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                amountMicroStx = _ref9.amountMicroStx, delegateTo = _ref9.delegateTo, untilBurnBlockHeight = _ref9.untilBurnBlockHeight, poxAddress = _ref9.poxAddress, privateKey = _ref9.privateKey;
                _context15.next = 3;
                return this.getPoxInfo();

              case 3:
                poxInfo = _context15.sent;
                contract = poxInfo.contract_id;
                txOptions = this.getDelegateOptions({
                  contract: contract,
                  amountMicroStx: amountMicroStx,
                  delegateTo: delegateTo,
                  untilBurnBlockHeight: untilBurnBlockHeight,
                  poxAddress: poxAddress
                });
                _context15.next = 8;
                return makeContractCall(Object.assign(Object.assign({}, txOptions), {
                  senderKey: privateKey
                }));

              case 8:
                tx = _context15.sent;
                return _context15.abrupt("return", broadcastTransaction(tx, txOptions.network));

              case 10:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function delegateStx(_x5) {
        return _delegateStx.apply(this, arguments);
      }

      return delegateStx;
    }()
  }, {
    key: "delegateStackStx",
    value: function () {
      var _delegateStackStx = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(_ref10) {
        var stacker, amountMicroStx, poxAddress, burnBlockHeight, cycles, privateKey, nonce, poxInfo, contract, txOptions, tx;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                stacker = _ref10.stacker, amountMicroStx = _ref10.amountMicroStx, poxAddress = _ref10.poxAddress, burnBlockHeight = _ref10.burnBlockHeight, cycles = _ref10.cycles, privateKey = _ref10.privateKey, nonce = _ref10.nonce;
                _context16.next = 3;
                return this.getPoxInfo();

              case 3:
                poxInfo = _context16.sent;
                contract = poxInfo.contract_id;
                txOptions = this.getDelegateStackOptions({
                  contract: contract,
                  stacker: stacker,
                  amountMicroStx: amountMicroStx,
                  poxAddress: poxAddress,
                  burnBlockHeight: burnBlockHeight,
                  cycles: cycles,
                  nonce: nonce
                });
                _context16.next = 8;
                return makeContractCall(Object.assign(Object.assign({}, txOptions), {
                  senderKey: privateKey
                }));

              case 8:
                tx = _context16.sent;
                return _context16.abrupt("return", broadcastTransaction(tx, txOptions.network));

              case 10:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function delegateStackStx(_x6) {
        return _delegateStackStx.apply(this, arguments);
      }

      return delegateStackStx;
    }()
  }, {
    key: "stackAggregationCommit",
    value: function () {
      var _stackAggregationCommit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17(_ref11) {
        var poxAddress, rewardCycle, privateKey, poxInfo, contract, txOptions, tx;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                poxAddress = _ref11.poxAddress, rewardCycle = _ref11.rewardCycle, privateKey = _ref11.privateKey;
                _context17.next = 3;
                return this.getPoxInfo();

              case 3:
                poxInfo = _context17.sent;
                contract = poxInfo.contract_id;
                txOptions = this.getStackAggregationCommitOptions({
                  contract: contract,
                  poxAddress: poxAddress,
                  rewardCycle: rewardCycle
                });
                _context17.next = 8;
                return makeContractCall(Object.assign(Object.assign({}, txOptions), {
                  senderKey: privateKey
                }));

              case 8:
                tx = _context17.sent;
                return _context17.abrupt("return", broadcastTransaction(tx, txOptions.network));

              case 10:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function stackAggregationCommit(_x7) {
        return _stackAggregationCommit.apply(this, arguments);
      }

      return stackAggregationCommit;
    }()
  }, {
    key: "revokeDelegateStx",
    value: function () {
      var _revokeDelegateStx = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18(privateKey) {
        var poxInfo, contract, txOptions, tx;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.getPoxInfo();

              case 2:
                poxInfo = _context18.sent;
                contract = poxInfo.contract_id;
                txOptions = this.getRevokeDelegateStxOptions(contract);
                _context18.next = 7;
                return makeContractCall(Object.assign(Object.assign({}, txOptions), {
                  senderKey: privateKey
                }));

              case 7:
                tx = _context18.sent;
                return _context18.abrupt("return", broadcastTransaction(tx, txOptions.network));

              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function revokeDelegateStx(_x8) {
        return _revokeDelegateStx.apply(this, arguments);
      }

      return revokeDelegateStx;
    }()
  }, {
    key: "getStackOptions",
    value: function getStackOptions(_ref12) {
      var amountMicroStx = _ref12.amountMicroStx,
          poxAddress = _ref12.poxAddress,
          cycles = _ref12.cycles,
          contract = _ref12.contract,
          burnBlockHeight = _ref12.burnBlockHeight;

      var _decodeBtcAddress2 = decodeBtcAddress(poxAddress),
          hashMode = _decodeBtcAddress2.hashMode,
          data = _decodeBtcAddress2.data;

      var hashModeBuffer = bufferCV(bigIntToBytes(BigInt(hashMode), 1));
      var hashbytes = bufferCV(data);
      var address = tupleCV({
        hashbytes: hashbytes,
        version: hashModeBuffer
      });

      var _this$parseContractId3 = this.parseContractId(contract),
          _this$parseContractId4 = _slicedToArray(_this$parseContractId3, 2),
          contractAddress = _this$parseContractId4[0],
          contractName = _this$parseContractId4[1];

      var network = this.network;
      var txOptions = {
        contractAddress: contractAddress,
        contractName: contractName,
        functionName: 'stack-stx',
        functionArgs: [uintCV(amountMicroStx), address, uintCV(burnBlockHeight), uintCV(cycles)],
        validateWithAbi: true,
        network: network,
        anchorMode: AnchorMode.Any
      };
      return txOptions;
    }
  }, {
    key: "getDelegateOptions",
    value: function getDelegateOptions(_ref13) {
      var contract = _ref13.contract,
          amountMicroStx = _ref13.amountMicroStx,
          delegateTo = _ref13.delegateTo,
          untilBurnBlockHeight = _ref13.untilBurnBlockHeight,
          poxAddress = _ref13.poxAddress;
      var address = undefined;

      if (poxAddress) {
        var _decodeBtcAddress3 = decodeBtcAddress(poxAddress),
            hashMode = _decodeBtcAddress3.hashMode,
            data = _decodeBtcAddress3.data;

        var hashModeBuffer = bufferCV(bigIntToBytes(BigInt(hashMode), 1));
        var hashbytes = bufferCV(data);
        address = someCV(tupleCV({
          hashbytes: hashbytes,
          version: hashModeBuffer
        }));
      }

      var _this$parseContractId5 = this.parseContractId(contract),
          _this$parseContractId6 = _slicedToArray(_this$parseContractId5, 2),
          contractAddress = _this$parseContractId6[0],
          contractName = _this$parseContractId6[1];

      var network = this.network;
      var txOptions = {
        contractAddress: contractAddress,
        contractName: contractName,
        functionName: 'delegate-stx',
        functionArgs: [uintCV(amountMicroStx), standardPrincipalCV(delegateTo), untilBurnBlockHeight ? someCV(uintCV(untilBurnBlockHeight)) : noneCV(), address ? address : noneCV()],
        validateWithAbi: true,
        network: network,
        anchorMode: AnchorMode.Any
      };
      return txOptions;
    }
  }, {
    key: "getDelegateStackOptions",
    value: function getDelegateStackOptions(_ref14) {
      var contract = _ref14.contract,
          stacker = _ref14.stacker,
          amountMicroStx = _ref14.amountMicroStx,
          poxAddress = _ref14.poxAddress,
          burnBlockHeight = _ref14.burnBlockHeight,
          cycles = _ref14.cycles,
          nonce = _ref14.nonce;

      var _decodeBtcAddress4 = decodeBtcAddress(poxAddress),
          hashMode = _decodeBtcAddress4.hashMode,
          data = _decodeBtcAddress4.data;

      var hashModeBuffer = bufferCV(bigIntToBytes(BigInt(hashMode), 1));
      var hashbytes = bufferCV(data);
      var address = tupleCV({
        hashbytes: hashbytes,
        version: hashModeBuffer
      });

      var _this$parseContractId7 = this.parseContractId(contract),
          _this$parseContractId8 = _slicedToArray(_this$parseContractId7, 2),
          contractAddress = _this$parseContractId8[0],
          contractName = _this$parseContractId8[1];

      var network = this.network;
      var txOptions = {
        contractAddress: contractAddress,
        contractName: contractName,
        functionName: 'delegate-stack-stx',
        functionArgs: [standardPrincipalCV(stacker), uintCV(amountMicroStx), address, uintCV(burnBlockHeight), uintCV(cycles)],
        validateWithAbi: true,
        network: network,
        anchorMode: AnchorMode.Any
      };

      if (nonce) {
        txOptions.nonce = nonce;
      }

      return txOptions;
    }
  }, {
    key: "getStackAggregationCommitOptions",
    value: function getStackAggregationCommitOptions(_ref15) {
      var contract = _ref15.contract,
          poxAddress = _ref15.poxAddress,
          rewardCycle = _ref15.rewardCycle;

      var _decodeBtcAddress5 = decodeBtcAddress(poxAddress),
          hashMode = _decodeBtcAddress5.hashMode,
          data = _decodeBtcAddress5.data;

      var hashModeBuffer = bufferCV(bigIntToBytes(BigInt(hashMode), 1));
      var hashbytes = bufferCV(data);
      var address = tupleCV({
        hashbytes: hashbytes,
        version: hashModeBuffer
      });

      var _this$parseContractId9 = this.parseContractId(contract),
          _this$parseContractId10 = _slicedToArray(_this$parseContractId9, 2),
          contractAddress = _this$parseContractId10[0],
          contractName = _this$parseContractId10[1];

      var network = this.network;
      var txOptions = {
        contractAddress: contractAddress,
        contractName: contractName,
        functionName: 'stack-aggregation-commit',
        functionArgs: [address, uintCV(rewardCycle)],
        validateWithAbi: true,
        network: network,
        anchorMode: AnchorMode.Any
      };
      return txOptions;
    }
  }, {
    key: "getRevokeDelegateStxOptions",
    value: function getRevokeDelegateStxOptions(contract) {
      var _this$parseContractId11 = this.parseContractId(contract),
          _this$parseContractId12 = _slicedToArray(_this$parseContractId11, 2),
          contractAddress = _this$parseContractId12[0],
          contractName = _this$parseContractId12[1];

      var network = this.network;
      var txOptions = {
        contractAddress: contractAddress,
        contractName: contractName,
        functionName: 'revoke-delegate-stx',
        functionArgs: [],
        validateWithAbi: true,
        network: network,
        anchorMode: AnchorMode.Any
      };
      return txOptions;
    }
  }, {
    key: "getStatus",
    value: function () {
      var _getStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        var poxInfo, _this$parseContractId13, _this$parseContractId14, contractAddress, contractName, account, functionName;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.getPoxInfo();

              case 2:
                poxInfo = _context19.sent;
                _this$parseContractId13 = this.parseContractId(poxInfo.contract_id), _this$parseContractId14 = _slicedToArray(_this$parseContractId13, 2), contractAddress = _this$parseContractId14[0], contractName = _this$parseContractId14[1];
                _context19.next = 6;
                return this.getAccountStatus();

              case 6:
                account = _context19.sent;
                functionName = 'get-stacker-info';
                return _context19.abrupt("return", callReadOnlyFunction({
                  contractAddress: contractAddress,
                  contractName: contractName,
                  functionName: functionName,
                  senderAddress: this.address,
                  functionArgs: [standardPrincipalCV(this.address)],
                  network: this.network
                }).then(function (responseCV) {
                  if (responseCV.type === ClarityType.OptionalSome) {
                    var _someCV = responseCV;
                    var _tupleCV = _someCV.value;
                    var poxAddress = _tupleCV.data['pox-addr'];
                    var amountMicroStx = _tupleCV.data['amount-ustx'];
                    var firstRewardCycle = _tupleCV.data['first-reward-cycle'];
                    var lockPeriod = _tupleCV.data['lock-period'];
                    var version = poxAddress.data['version'];
                    var hashbytes = poxAddress.data['hashbytes'];
                    return {
                      stacked: true,
                      details: {
                        amount_microstx: amountMicroStx.value.toString(),
                        first_reward_cycle: Number(firstRewardCycle.value),
                        lock_period: Number(lockPeriod.value),
                        unlock_height: account.unlock_height,
                        pox_address: {
                          version: version.buffer,
                          hashbytes: hashbytes.buffer
                        }
                      }
                    };
                  } else if (responseCV.type === ClarityType.OptionalNone) {
                    return {
                      stacked: false
                    };
                  } else {
                    throw new Error("Error fetching stacker info");
                  }
                }));

              case 9:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getStatus() {
        return _getStatus.apply(this, arguments);
      }

      return getStatus;
    }()
  }, {
    key: "modifyLockTxFee",
    value: function modifyLockTxFee(_ref16) {
      var tx = _ref16.tx,
          amountMicroStx = _ref16.amountMicroStx;
      var fee = getFee(tx.auth);
      tx.payload.functionArgs[0] = uintCV(intToBigInt(amountMicroStx, false) - fee);
      return tx;
    }
  }, {
    key: "parseContractId",
    value: function parseContractId(contract) {
      var parts = contract.split('.');

      if (parts.length !== 2 || !validateStacksAddress(parts[0]) || parts[1] !== 'pox') {
        throw new Error('Stacking contract ID is malformed');
      }

      return parts;
    }
  }]);

  return StackingClient;
}();